<div class="error-container">
    <div class="error-icon">
        <warema-svg-icon filePath="assets/images/icons/icon_error.svg" height="30" width="30" />
    </div>
    <div class="oops-label">{{ 'OOPS' | translate }}</div>
    <div class="error-occurred-label">{{ 'SORRY_ERROR_OCCURRED' | translate }}</div>

    <div class="do-not-worry-label">{{ 'BUT_DO_NOT_WORRY' | translate }}</div>
    <div class="inputs-saved-label">{{ 'ALL_YOUR_INPUTS_HAVE_BEEN_SAVED' | translate }}</div>
    @if (errorScreenContent && errorScreenContent.buttonContent) {
        <div class="what-to-do-next">
            {{ 'ERRORS.' + errorScreenContent.whatToDoNext | translate }}
        </div>
    }

    <div class="button-container">
        @if (errorScreenContent) {
            <warema-button
                class="back-button"
                [text]="
                    errorScreenContent.buttonContent
                        ? ('ERRORS.' + errorScreenContent.buttonContent | translate)
                        : ('BACK_TO_PREVIOUS_PAGE' | translate)
                "
                (click)="goBack()"
            />
        }
    </div>
</div>
